/**
 * Returns a path with the BASEPATH prepended to it, for branch deployments.
 *
 * Always use this when navigating using the `history` object outside of the
 * React context, e.g. in sagas or middlewares.
 */
export const pathWithBasename = (path: string): string =>
  path.startsWith(BASEPATH) ? path : `${BASEPATH}${path}`.replace('//', '/');
